import React from "react";
import { useSelector } from "react-redux";
import { fgfChildThemes } from "@theme/config";
import {Wrapper} from "@containers/PageWrapper";
import { TopHeader } from "@components/topHeader";
import { Footer } from "@components/footer";
import { Push } from "@components/push";
import { useGetTitle } from "../PersonalLoan/context/formContext/header";

export const PageWrapper = ({children, className, renderHeaderBottom = () => {}}) => {
  const themeName = useSelector(state => state.StartUp.theme);
  let customClass = '';
  if(className) {
    customClass = className;
  }
  if(fgfChildThemes.includes(themeName)) {
    customClass = customClass + ' extend-footer';
  }
  const mobileHeader = useGetTitle();

  return (
    <>
      <Wrapper className={customClass}>
        <TopHeader mobileHeader={mobileHeader} renderHeaderBottom={renderHeaderBottom}>
        </TopHeader>
        {children}
        <Push />
      </Wrapper>
      <Footer />
    </>
  );
}